// ==========================================================================
// Telegram Auth Service - Mini-App initData verification
// Endpoint matches: POST /api/auth/telegram/verify (E12)
// ==========================================================================

import api from '@/lib/axios';
import type { AuthResponse } from '@/types/auth.types';

interface VerifyInitDataRequest {
  init_data: string;
  start_payload?: string;
}

/**
 * Exchange a Telegram WebApp initData query string for a Sanctum access
 * token. Backend verifies the HMAC, finds-or-creates the User, and returns
 * { access_token, user (with fsp) }. 401 → initData was tampered or expired
 * (the user must reopen the Mini-App from Telegram to get fresh data).
 */
export async function verifyInitData(payload: VerifyInitDataRequest): Promise<AuthResponse> {
  const response = await api.post<AuthResponse>('/auth/telegram/verify', payload);
  return response.data;
}
